export default __webpack_public_path__ + "static/media/i1.8182fed6.jpg";